import { render, staticRenderFns } from "./tyc.vue?vue&type=template&id=89e554c2&"
import script from "./tyc.vue?vue&type=script&lang=js&"
export * from "./tyc.vue?vue&type=script&lang=js&"
import style0 from "./tyc.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "../iniciarSesion/iniciarSesion.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports